<template>
  <div class="pengaturan-paket-epayment">
    <SOSlotBase :container-name="`pengaturan-masa-aktif-e-payment`" :loading="pageLoading">
      <template v-slot:loading-page>
        <SOLoadingPage/>
      </template>
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Masa Aktif E-Payment'" :type="'back'" @back="back" />
      </template>
      <template v-slot:content>
        <div class="p-x-20 paket-epayment-content">
          <form>
            <div class="form-group">
              <div class="m-t-12">
                <label class="m-0 require f-regular f-14 f-c-midgrey" for="jenis-paket-e-payment">
                  Jenis Paket
                </label>
                <SOInputOnOff
                  :disabled="!validateAccess('epaymentActivePeriod.update')"
                  :checkboxes="tipePaket"
                  @selected="
                    (e) => {
                      toogleOnOff(e, 'jenis_emoney');
                    }
                  "
                  :checked="jenisEmoney == 1 ? true : false"
                />
              </div>
            </div>
            <div class="bg-yellow p-x-20 p-y-8 d-flex align-items-center" style="margin: 0 -20px" v-if="settingChanged">
              <img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12">
              <div class="f-regular f-12 f-c-midgrey">
                Aturan baru berlaku untuk semua paket E-Payment di semua outlet dan <b>tidak akan mempengaruhi aturan
                E-Payment yang sedang dimiliki konsumen</b>, sampai konsumen melakukan top up.
              </div>
            </div>
            <div class="separator m-x-min"></div>
            <div v-if="jenisEmoney == 1">
              <div class="form-row m-t-12" v-if="false">
                <div class="form-group col-md-12 col-sm-12 col-12">
                  <SOInputNominal
                    :title="'Masa Aktif'"
                    :required="true"
                    :prefix-right="true"
                    :placeholder="'30'"
                    :prefix="'Hari'"
                    :defaultValue="inputNominal.masa_aktif_emoney.formatted"
                    v-model="inputNominal.masa_aktif_emoney"
                    @input="handleNominalChange($event, 'masa_aktif_emoney')"
                  />
                  <ErrorMessage class="error" label="Masa Aktif Paket" :validation="$v.epayment.masa_aktif_emoney" />
                </div>
              </div>
              <div class="m-t-12">
                <SoModalOptions
                  :disabled="!validateAccess('epaymentActivePeriod.update')"
                  :title="modalOptions.masaAktifPaket.title"
                  :selectedOption="tipeMasaAktif"
                  :options="modalOptions.masaAktifPaket.options"
                  :id="'akumulasi-masa-aktif'"
                  :required="true"
                  @onSelected="
                    (obj) => {
                      selectedOption(obj, 'tipe_perpanjangan_masa_aktif_emoney');
                    }
                  "
                />
                <ErrorMessage
                  class="error"
                  :label="modalOptions.masaAktifPaket.title"
                  :validation="$v.epayment.tipe_perpanjangan_masa_aktif_emoney"
                />
              </div>
              <div class="m-t-12">
                <SoModalOptions
                  :disabled="!validateAccess('epaymentActivePeriod.update')"
                  :title="modalOptions.jikaKedaluarsa.title"
                  :selectedOption="tipeExpired"
                  :options="modalOptions.jikaKedaluarsa.options"
                  :id="'tipe-quota-expired'"
                  :required="true"
                  @onSelected="
                    (obj) => {
                      selectedOption(obj, 'tipe_saldo_expired_emoney');
                    }
                  "
                />
                <ErrorMessage
                  class="error"
                  :label="modalOptions.jikaKedaluarsa.title"
                  :validation="$v.epayment.tipe_saldo_expired_emoney"
                />
              </div>
            </div>
          </form>
          <div class="save-btn">
            <SOButton
              :primary="true"
              :full="true"
              :text="jenisEmoney === 1 ? 'Selanjutnya' : 'Simpan'"
              :id="`set-paket-epayment`"
              :disable="!validateAccess('epaymentActivePeriod.update') && (isFetching || !settingChanged)"
              :loading="isFetching"
              @action="onSave"
            />
          </div>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SoModalOptions from "@/so-components/global/ui/SOModalOptions";
import SOButton from "@/so-components/global/ui/SOButton";

import ErrorMessage from "@/component-items/ErrorMessage";
import { minValue, required, maxValue } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";
import epaymentOptions from "../static/epaymentOptions";

const masaAktif = {
  limited: "Dengan Masa Aktif",
  unlimited: "Tanpa Masa Aktif (Selamanya)",
};

const tipePaketEpayment = (title = masaAktif.limited) => ({
  name: "jenis-paket",
  data: [
    {
      id: "jenis-paket-deposit",
      value: "1",
      title: `<label class='f-regular f-16 f-c-black m-0' for='jenis-paket-deposit'>${title}</label>`,
      checked: false,
      titleBold: false,
    },
  ],
});

export default {
  name: "PaketEPayment",
  components: {
    SOSlotBase,
    SOLoadingPage,
    SOTitleBar,
    SOInputOnOff,
    SOInputNominal,
    ErrorMessage,
    SOButton,
    SoModalOptions,
  },
  data() {
    return {
      tipePaket: tipePaketEpayment(),
      // inputNominal: {
      //   masa_aktif_emoney: {},
      // },
      epaymentDefaultValue: {},
      settingChanged: false,
      pageLoading: true,
      epaymentWatchReady: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.init();
    });
  },
  watch: {
    jenisEmoney: function(jenisBaru, jenisLama) {
      if (jenisBaru !== jenisLama) {
        this.tipePaket = tipePaketEpayment(jenisBaru == 1 ? masaAktif.limited : masaAktif.unlimited);
      }
    },
    immediate: true,

    epayment: {
      handler: function () {
        // console.log("jenis_emoney", this.epayment.jenis_emoney === this.epaymentDefaultValue.jenis_emoney)
        // console.log("tipe_perpanjangan_masa_aktif_emoney", this.epayment.tipe_perpanjangan_masa_aktif_emoney === this.epaymentDefaultValue.tipe_perpanjangan_masa_aktif_emoney)
        // console.log("tipe_saldo_expired_emoney", this.epayment.tipe_saldo_expired_emoney === this.epaymentDefaultValue.tipe_saldo_expired_emoney)
        if (this.epaymentWatchReady) {
          this.settingChanged = !(
            this.epayment.jenis_emoney === this.epaymentDefaultValue.jenis_emoney &&
            this.epayment.tipe_perpanjangan_masa_aktif_emoney === this.epaymentDefaultValue.tipe_perpanjangan_masa_aktif_emoney &&
            this.epayment.tipe_saldo_expired_emoney === this.epaymentDefaultValue.tipe_saldo_expired_emoney
          )
        }
      },
      deep: true
    },
  },
  validations: {
    epayment: {
      jenis_emoney: {
        required,
      },
      // masa_aktif_emoney: {
      //   required,
      //   minValue: minValue(1),
      //   // maxValue: maxValue(30),
      // },
      tipe_perpanjangan_masa_aktif_emoney: {
        required,
      },
      tipe_saldo_expired_emoney: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      epayment: "epayment",
      isFetching: "fetching",
    }),
    jenisEmoney() {
      return this.epayment.jenis_emoney;
    },
    tipeMasaAktif() {
      return this.epayment.tipe_perpanjangan_masa_aktif_emoney;
    },
    // masaAktif() {
    //   return this.epayment.masa_aktif_emoney;
    // },
    tipeExpired() {
      return this.epayment.tipe_saldo_expired_emoney;
    },
    modalOptions() {
      return epaymentOptions;
    },
    idOutlet() {
      return this.$route.query.idOutlet;
    },
    epaymentRouteType() {
      return this.$route.query.epaymentRouteType;
    },
    id() {
      return this.$route.query.id === undefined ? "create" : this.$route.query.id;
    }
  },
  mounted() {
    this.getBaseData()
  },
  methods: {
    ...mapActions({
      getSettingEpayment: `${moduleName}/getSettingEpayment`,
      updateEpayment: `${moduleName}/updateEpayment`,
      resetSettingEpayment: `${moduleName}/resetSettingEpayment`,
    }),
    async getBaseData() {
      this.pageLoading = true
      this.getSettingEpayment().then(() => {
        setTimeout(() => {
          this.epaymentDefaultValue = JSON.parse(JSON.stringify(this.epayment))
          this.epaymentWatchReady = true
          this.pageLoading = false
        }, 1000)
      })
    },
    async init() {
      let { jenisEmoney } = this;
      if (jenisEmoney === 1) {
        // this.inputNominal.masa_aktif_emoney = this.nominalFormat(this.masaAktif);
      }

      if (jenisEmoney) {
        this.tipePaket = tipePaketEpayment(jenisEmoney == 1 ? masaAktif.limited : masaAktif.unlimited);
      }
    },
    back() {
      if (this.idOutlet) {
        this.$router.push(`/addOutlet/${this.idOutlet}/emoney/${this.epaymentRouteType}/${this.id}`);
      } else {
        this.$router.push({ name: "pengaturanUmum.dashboard" });
      }
    },
    toogleOnOff(isChecked, target) {
      let jenisEmoney = 2;
      if (isChecked) {
        jenisEmoney = 1;
        if (!this.tipeMasaAktif) {
          this.updateEpayment({ key: "tipe_perpanjangan_masa_aktif_emoney", val: 1 });
        }

        if (!this.tipeExpired) {
          this.updateEpayment({ key: "tipe_saldo_expired_emoney", val: 1 });
        }
      } else {
        // this.resetSettingEpayment();
        this.updateEpayment({ key: "jenis_emoney", val: 2 });
        this.updateEpayment({ key: "tipe_perpanjangan_masa_aktif_emoney", val: 0 });
        this.updateEpayment({ key: "tipe_saldo_expired_emoney", val: 0 });
      }
      this.updateEpayment({ key: target, val: jenisEmoney });
    },
    errorValidation() {
      let {
        jenis_emoney,
        // masa_aktif_emoney,
        tipe_perpanjangan_masa_aktif_emoney,
        tipe_saldo_expired_emoney,
      } = this.$v.epayment;

      jenis_emoney.$touch();
      let isValid = jenis_emoney.$invalid;

      if (this.jenisEmoney == 1) {
        // masa_aktif_emoney.$touch();
        tipe_perpanjangan_masa_aktif_emoney.$touch();
        tipe_saldo_expired_emoney.$touch();

        isValid =
          isValid ||
          // masa_aktif_emoney.$invalid ||
          tipe_perpanjangan_masa_aktif_emoney.$invalid ||
          tipe_saldo_expired_emoney.$invalid;
      }

      return isValid;
    },
    handleNominalChange(val, target) {
      this.updateEpayment({ key: target, val: val.raw });
    },
    selectedOption(obj, target) {
      this.updateEpayment({ key: target, val: obj.value });
    },
    onSave() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }

      this.$router.push({ name: "pengaturanUmum.confirm_setting", query: { idOutlet: this.idOutlet, epaymentRouteType: this.epaymentRouteType, id: this.id } });
    },
    nominalFormat(value) {
      if (typeof value !== "number") {
        return {
          raw: 0,
          formatted: "0",
        };
      }

      return {
        raw: value,
        formatted: Number.isInteger(value)
          ? value.toString()
          : value
              .toFixed(2)
              .toString()
              .replace(".", ","),
      };
    },
  },
};
</script>
<style scoped>
.pengaturan-paket-epayment .separator {
  width: unset;
}
.pengaturan-paket-epayment .paket-epayment-content {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  height: 100vh;
  padding-bottom: 60px;
}
.pengaturan-paket-epayment .save-btn {
  align-self: end;
  padding-bottom: 60px;
}
</style>
